import { GridFilterItem } from '@mui/x-data-grid/models';

export const filterItemEquals = (field: string, value: string | number): GridFilterItem => ({
  id: field,
  field,
  operator: 'equals',
  value,
});
